<div class="contant-dialog">
  <form [formGroup]="form">
    <div class="dialog-scroll-content">
      <div class="d-flex orang-title align-items-center">
        <i class="schedulePropeties-icon"></i>
        <div class="orang-text">הוספת מערכת שעות כיתתית</div>
      </div>

      <div class="contant-inputs">
        <div class="a">
          <div class="b input-worp first-worp">
            <div class="txt">כיתה<div class="required">*</div>
            </div>
            <div class="selectDiv e">
              <select formControlName="class" class="input-a" [ngClass]="{required: form.controls.class.errors}">
                <option value="">בחר כיתה</option>
                <option *ngFor="let class of classes" [ngValue]="class">{{ class.viewValue }}</option>
              </select>
            </div>
          </div>

          <div class="b input-worp first-worp">
            <div class="txt">מספר כיתה</div>
            <div class="selectDiv e">
              <select formControlName="classNumber" class="input-a"
                [ngClass]="{required: form.controls.classNumber.errors}">
                <option value="">בחר מספר</option>
                <option *ngFor="let number of classNumbers" [ngValue]="number">{{ number.viewValue }}</option>
              </select>
            </div>
          </div>

          <div class="b input-worp first-worp">
            <div class="txt">סוג תגבור</div>
            <div class="selectDiv e">
              <select formControlName="supportType" class="input-a"
                [ngClass]="{required: form.controls.supportType.errors}">
                <option value="">בחר סוג תגבור</option>
                <option *ngFor="let type of supportTypes" [ngValue]="type">{{ type.viewValue }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="contant-buttons d-flex justify-content-end">
        <button class="cancel-save-button" mat-dialog-close [disabled]="loading">ביטול</button>
        <button class="save-button buttonload" [disabled]="form.invalid || loading" (click)="save()">שמור</button>
      </div>
    </div>
  </form>
</div>